import React, { useRef, useEffect } from 'react';
import { Check } from 'lucide-react';

const ESTADOS = [
  { id: 'planificacion', label: 'PLANIFICACIÓN', color: '#dc2626', bgColor: '#fee2e2' },
  { id: 'en-curso', label: 'EN CURSO', color: '#2563eb', bgColor: '#dbeafe' },
  { id: 'finalizado', label: 'FINALIZADA', color: '#16a34a', bgColor: '#dcfce7' },
];

const StatusPopover = ({ currentStatus, onSelect, position, onClose }) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div
      ref={popoverRef}
      className="fixed z-50 bg-white rounded-lg shadow-lg border border-gray-200"
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        minWidth: '200px',
      }}
    >
      <div className="p-2">
        {ESTADOS.map((estado) => (
          <button
            key={estado.id}
            onClick={() => {
              onSelect(estado.id);
              onClose();
            }}
            className="w-full text-left px-3 py-2 rounded-md transition flex items-center justify-between hover:bg-gray-100 group"
          >
            <div className="flex items-center gap-2">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: estado.color }}
              />
              <span className="text-sm font-medium text-gray-700">
                {estado.label}
              </span>
            </div>
            {currentStatus === estado.id && (
              <Check className="w-4 h-4 text-blue-500" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default StatusPopover;
